import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { __assign } from "tslib";
import { uniCall } from '../../utils';
export var shareChannelMap = {
  weixin: 'weixin',
  weixin_circle: 'weixin_circle',
  qq: 'qq',
  qzone: 'qzone',
  weibo: 'weibo',
  save_photo: 'save_photo',
  // 旧版本客户端 API 存在字段不一致的场景，需要抹平
  session: 'weixin',
  timeline: 'weixin_circle',
  qq_session: 'qq',
  qq_timeline: 'qzone'
};
/**
 * 调用 JSAPI `shareEx` 触发分享动作
 */

export function commitShare(opt) {
  var option = __assign({}, opt);

  if (!('stat' in option)) {
    option.stat = {
      production: 'baicizhan',
      pageName: '',
      pageId: ''
    };
  }

  if (!option.shareType) {
    option.shareType = 'h5';
  }

  if (option.shareType === 'h5') {
    if (!option.url) {
      option.url = "".concat(location.pathname);
    }

    if (!/^(?:https?:)?\/\//.test(option.url)) {
      option.url = "".concat(location.origin).concat(option.url);
    }
  }

  if (option.shareType === 'image') {
    // 移除逗号（含）前面的标识段，如 `data:image/png;base64,`
    option.imgData = String(option.imgData).replace(/^[^,]+?,/, '');

    if (!('desc' in option)) {
      option.desc = '';
    } // Force `option.title` to empty string
    // to prevent baicizhan@iOS from reading `document.title` as fallback value


    option['title'] = '';
  }

  if (option.shareType === 'mini-program') {
    if (!('programType' in option)) {
      option.programType = 0;
    }

    if (!('withShareTicker' in option)) {
      option.withShareTicket = false;
    }

    if (!('disableForward' in option)) {
      option.disableForward = false;
    }
  }

  uniCall({
    api: 'shareEx',
    param: JSON.stringify(option)
  });
}